import React, { useState } from 'react';
import Text from '../../atoms/Text';
import {
	ANALYTICS_EVENTS,
	EVENT_TYPES,
} from '../../../shared/constants/events';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import useEvents from '../../../hooks/useEvents';

interface Props {
	title?: string;
	children?: React.ReactNode;
	href?: string;
	showButton?: boolean;
	sx?: string;
	headerButton?: React.ReactNode;
}

const HomeCard: React.FC<Props> = ({
	title,
	children,
	showButton,
	href,
	sx,
	headerButton,
}) => {
	const [isHover, setIsHover] = useState(false);
	const userProfile = useSelector((state: RootState) => state.profile.user);
	const { trackEvent } = useEvents();

	const logCTEvent = () => {
		if (!title) return;
		const source = title.toLowerCase().replaceAll(' ', '_');
		if (userProfile) {
			trackEvent({
				eventName: ANALYTICS_EVENTS.HOME_LINK,
				eventPayload: {
					event_type: EVENT_TYPES.HOME_LINK_INTERACTION,
					id: userProfile?.id,
					phone: userProfile?.cellphone,
					source,
				},
			});
		}
	};
	return (
		<section
			onMouseEnter={() => setIsHover(true)}
			onMouseLeave={() => setIsHover(false)}
			className={`flex flex-col p-4 bg-white shadow-sm rounded-xl relative ${sx}`}
		>
			<div
				className={`${isHover && showButton ? 'opacity-25' : 'opacity-100'}`}
			>
				<div className='flex flex-row justify-between items-center mb-2'>
					{title && (
						<>
							<p className='text-lg font-medium hidden lg:block'>{title}</p>
							<Text
								size='body-3'
								weight='bold'
								sx='block lg:hidden'
							>
								{title}
							</Text>
						</>
					)}
					<>{headerButton}</>
				</div>
				<div className='border border-b-h-gray-20 mb-2' />

				<>{children}</>
			</div>
			{showButton && isHover && (
				<a
					onClick={logCTEvent}
					href={href}
					className='bg-h-primary rounded-lg border text-white text-center w-[284px] px-8 py-6 h-max left-1/2 top-1/2 translate-y-[-50%] translate-x-[-50%] absolute m-0'
				>
					Debes vincularte para descargar o compartir
				</a>
			)}
		</section>
	);
};

export default React.memo(HomeCard);
